import { message, Table } from 'antd'
import dayjs from '../../Utils/date'
import React, { useEffect, useState } from 'react'
import apiClient from '../../Utils/apiClient'
import Button from '../Button'

const VersionHistory = ({ documentId }) => {
  const [versions, setVersions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!documentId) {
      return
    }

    apiClient
      .get(`documents/${documentId}/versions`)
      .then((res) => setVersions(res.data?.result || []))
      .finally(() => setLoading(false))
  }, [documentId])

  const onRestore = (versionId) => {
    apiClient.put(`documents/versions/${versionId}/restore`).then(() => {
      message.success('Version restored')
    })
  }

  return (
    <Table
      size="small"
      loading={loading}
      pagination={false}
      dataSource={versions.map((v) => ({ ...v, key: v._id || v.id }))}
      columns={[
        { title: 'Version', dataIndex: 'version', key: 'version' },
        { title: 'File', dataIndex: 'filename', key: 'filename' },
        {
          title: 'Date',
          dataIndex: 'replacedAt',
          key: 'replacedAt',
          render: (v) => (v ? dayjs(v).format('MMM D, YYYY h:mm A') : '-')
        },
        {
          title: '',
          key: 'action',
          render: (_, row) => (
            <Button variant="primary" onClick={() => onRestore(row._id || row.id)}>
              Restore
            </Button>
          )
        }
      ]}
    />
  )
}

export default VersionHistory
